import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "./theme-provider";
const ThemeToggle = () => {
    const { theme, setTheme } = useTheme();
    return (_jsxs("button", { onClick: () => setTheme(theme === "dark" ? "light" : "dark"), className: "p-2 rounded-md hover:bg-accent hover:text-accent-foreground transition-colors", children: [theme === "dark" ? (_jsx(Sun, { className: "h-5 w-5 animate-in fade-in-0 zoom-in-95" })) : (_jsx(Moon, { className: "h-5 w-5 animate-in fade-in-0 zoom-in-95" })), _jsx("span", { className: "sr-only", children: "Toggle theme" })] }));
};
export default ThemeToggle;
